const appCoreActionTypes = {
	APP_INITIALIZE: "@app/core/INITIALIZE", // COMMAND ACTION
	APP_RESET: "@app/core/RESET", // COMMAND ACTION
};
export default appCoreActionTypes;
